import api from "./instance";

export const getNotifications = () => api.get("/staff/notifications");

export const markNotificationsRead = (notificationId) =>
  api.post(
    "/staff/notifications/mark-read",
    notificationId ? { notificationId } : {}
  );
